import * as serviceVehiclesServices from './serviceVehiclesServices';

export { serviceVehiclesServices };
